module.exports = __webpack_public_path__ + "img/flag-portugese.6582b81c.jpg";